import { Spine } from 'pixi-spine'
import { SpineUtils } from 'utils/Spine-Utils'

import GambleTitle from './GambleTitle'
export default  class HistorySpine extends  Spine {
  constructor(data) {
    super(data.spineData)
    this._data = data
    this._title = null
    this._generateTitle(data)
  }

  _generateTitle(data){
    const text = this._title = new GambleTitle(data.title)
    if(data.title.hasOwnProperty('mirror')){
      text.scale.set(-1, 1)
    }
    SpineUtils.addText(this, data.title.slotName, text, data.title.pos)
  }

  updateTextKey(value){
    this._title.updateTextKey(this._data.title.state[value])
  }

  playCallBack(animationName, loop = false, cb) {
    if (this.state.hasAnimation(animationName)) {
      this._animated = true
      this.anim =  this.state.setAnimation(0, animationName, loop)
    }
    else {
      throw new Error(`There is no animation with name: ${animationName}`)
    }

    if (!cb) {
      return
    }

    this.state.tracks[0].listener = {
      complete: () => {
        if(cb){
          cb()
          cb = () => {}
        }
      },
    }
  }

}
